const Z_INDEX_MAX = 2147483647;
const Z_LAUNCHER = Z_INDEX_MAX;
const Z_COMMANDBAR = Z_INDEX_MAX - 2;
const Z_EDITOR = Z_INDEX_MAX - 3;
const Z_EDITOR_OVERLAY = Z_INDEX_MAX - 2;
const Z_CARETAKER = Z_INDEX_MAX - 2;
const Z_TOOLTIPS = Z_INDEX_MAX;
const Z_MESSAGES = Z_INDEX_MAX;
const Z_DRAGGERS = Z_INDEX_MAX;
const Z_MODALS = Z_INDEX_MAX;
const Z_RECORDER = Z_INDEX_MAX - 1;
const Z_DROPDOWNS = Z_INDEX_MAX - 1;
const Z_KEYBOARD_SHORTCUTS = Z_INDEX_MAX - 1;
const Z_CONFETTI = Z_INDEX_MAX;
const Z = {
    Z_INDEX_MAX,
    Z_LAUNCHER,
    Z_MESSAGES,
    Z_COMMANDBAR,
    Z_EDITOR,
    Z_EDITOR_OVERLAY,
    Z_CARETAKER,
    Z_DROPDOWNS,
    Z_TOOLTIPS,
    Z_MODALS,
    Z_RECORDER,
    Z_DRAGGERS,
    Z_KEYBOARD_SHORTCUTS,
    Z_CONFETTI,
};
export default Z;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9jbGllbnQvWi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxXQUFXLEdBQUcsVUFBVSxDQUFDO0FBRS9CLE1BQU0sVUFBVSxHQUFHLFdBQVcsQ0FBQztBQUUvQixNQUFNLFlBQVksR0FBRyxXQUFXLEdBQUcsQ0FBQyxDQUFDO0FBQ3JDLE1BQU0sUUFBUSxHQUFHLFdBQVcsR0FBRyxDQUFDLENBQUM7QUFDakMsTUFBTSxnQkFBZ0IsR0FBRyxXQUFXLEdBQUcsQ0FBQyxDQUFDO0FBQ3pDLE1BQU0sV0FBVyxHQUFHLFdBQVcsR0FBRyxDQUFDLENBQUM7QUFFcEMsTUFBTSxVQUFVLEdBQUcsV0FBVyxDQUFDO0FBQy9CLE1BQU0sVUFBVSxHQUFHLFdBQVcsQ0FBQztBQUMvQixNQUFNLFVBQVUsR0FBRyxXQUFXLENBQUM7QUFDL0IsTUFBTSxRQUFRLEdBQUcsV0FBVyxDQUFDO0FBQzdCLE1BQU0sVUFBVSxHQUFHLFdBQVcsR0FBRyxDQUFDLENBQUM7QUFDbkMsTUFBTSxXQUFXLEdBQUcsV0FBVyxHQUFHLENBQUMsQ0FBQztBQUNwQyxNQUFNLG9CQUFvQixHQUFHLFdBQVcsR0FBRyxDQUFDLENBQUM7QUFDN0MsTUFBTSxVQUFVLEdBQUcsV0FBVyxDQUFDO0FBRS9CLE1BQU0sQ0FBQyxHQUFHO0lBQ1IsV0FBVztJQUNYLFVBQVU7SUFDVixVQUFVO0lBQ1YsWUFBWTtJQUNaLFFBQVE7SUFDUixnQkFBZ0I7SUFDaEIsV0FBVztJQUNYLFdBQVc7SUFDWCxVQUFVO0lBQ1YsUUFBUTtJQUNSLFVBQVU7SUFDVixVQUFVO0lBQ1Ysb0JBQW9CO0lBQ3BCLFVBQVU7Q0FDWCxDQUFDO0FBRUYsZUFBZSxDQUFDLENBQUMifQ==